const ReportTabComponent = ({ category, handleCheckboxChange, active, tab, searchTerm = '' }) => {
    return (
        <>
            <div style={{ height: `${active === 'cardAcceptances' ? '230px' : '204px'}`, overflowY: 'scroll', overflowX: 'hidden', marginTop: 10 }}>
                <div className="px-4 py-3" >
                    {category?.map((item, index) => {
                        return item.label.toLowerCase().includes(searchTerm.toLowerCase()) ? (
                            <div key={index} className="d-flex align-items-center column-gap-3 mb-2">
                                <input
                                    className="report-headers"
                                    type="checkbox"
                                    name={item.value}
                                    checked={item.checked}
                                    onChange={(e) => { handleCheckboxChange(e, item, tab) }}
                                    style={{ width: 14, height: 14, cursor: 'default !important', ':hover': { cursor: 'pointer !important' } }}
                                    readOnly={false}
                                />
                                <label htmlFor={item.value} style={{ fontSize: 11 }}>{item.label}</label>
                            </div>
                        ) : <></>
                    })}
                </div>
            </div>
        </>
    )
}

export default ReportTabComponent;